module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "fmh",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062839312_Contents#r_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("Epigraph")])])])]), _vm._v(" "), _c('p', {
    staticClass: "pepi"
  }, [_vm._v("To speak of knowledge is futile. All is experiment and adventure.")]), _vm._v(" "), _c('p', {
    staticClass: "pepi"
  }, [_vm._v("We are forever mixing ourselves with unknown quantities.")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "peps"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VIRGINIA WOOLF,")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps_italic"
  }, [_vm._v("THE WAVES")]), _c('span', {
    staticClass: "smallcaps"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28e13284","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062839312_Epigraph.vue
// module id = 66
// module chunks = 0